export const MESSAGES = {
	USAGE_NOTICE: "このツールは個人的な使用を目的としています。商用利用をすることはできません。",
	COPYRIGHT_NOTICE: "© 2024 Your Company. All rights reserved.",
	// 他の再利用可能なメッセージや定数
  };